import React, { useEffect } from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

type LocationState = {
  fromRappelConseiller?: boolean;
};

export const ValidationRappelConseiller: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locationState = useLocation().state as LocationState | null;
  const { user } = useAuth();
  const fromRappelConseiller = locationState?.fromRappelConseiller;

  useEffect(() => {
    if (user?.id && user.type && user.success) {
      TRACKING_INSTANCE.setTcVars({
        page_nom: 'besoin d aide',
        page_template: 'espace client',
        user_id: user.id,
        user_client: user.type === 'Client',
        user_connexion: user?.success,
        user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
      });
      void TRACKING_INSTANCE.triggerEvent('page', undefined, {
        event_id: 'page',
        event_categorie: 'affichage espace client',
        event_nom: 'besoin d aide - web call back',
        event_page: 'besoin d aide',
      });
    }
  }, [user?.id, user?.type, user?.success]);

  if (!fromRappelConseiller) {
    return <Navigate to={ROUTE.DASHBOARD} replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <i className={`totem-icon totem-icon-check-circle-solid ${styles.successIcon}`} />

        <div className={styles.messageButton}>
          <div className={styles.message}>
            <p className={styles.requestTitle}>{t('helpContact.requestConfirmation')}</p>

            <p className={styles.advisorMessage}>{t('helpContact.advisorCallback')}</p>
          </div>

          <div>
            <MtxButton
              onClick={() => {
                navigate(ROUTE.DASHBOARD);
              }}
              variant="primary"
              size="medium"
              full-width="true"
            >
              <div>{t('common.backToHome')}</div>
            </MtxButton>
          </div>
        </div>
      </div>
    </div>
  );
};
